<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    append-icon="mdi-chevron-down"
    :color="defaultColor"
    persistent-placeholder
    :class="[
      mainClass,
      $attrs.class,
    ]"
    :style="[
      $attrs.style,
    ]"
    @input="$emit('input', $event)">
    <template v-if="$scopedSlots.selection" v-slot:selection="slotProps">
      <slot name="selection" v-bind="slotProps" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "MajorityAutocomplete",

  inheritAttrs: false,

  props: {
    value: [String, Number, Boolean, Object, Array],

    regular: {
      type: Boolean,
      default: false,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    defaultColor: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    mainClass() {
      return {
        'autocomplete-default autocomplete-regular': this.regular,
        'autocomplete-default autocomplete-outlined': this.outlined,
      };
    }
  }

}
</script>

<style lang="scss">
.autocomplete-default {
  > .v-input__control {
    ::before {
        border-image: none !important;
      }

    > .v-input__slot {
      padding: 0 12px !important;
      min-height: 50px;

      > .v-text-field__slot {
        margin: 0 !important;
        height: 100%;
      }

      &::before,
      &::after,
      :before,
      :after {
        border-color: transparent !important;
        background-color: transparent !important;
      }

      label {
        padding: 0 8px;
        font-size: 16px;
        color: var(--v-foreground-base);
        max-width: 133%;
      }
    }
  }
}

.autocomplete-regular {
  margin: 0px !important;
  padding: 0px !important;

  > .v-input__control {
    > .v-input__slot {
      border: 2px solid color-mix(in srgb, var(--v-border-base), transparent 9%) !important;
      border-radius: 8px;

      label {
        background-color: var(--v-muted-base);
        transform: translate(-6px, -26px) scale(0.75);
        pointer-events: auto;
      }
    }
  }
}

.autocomplete-outlined {
  > .v-input__control {
    > .v-input__slot {
      border: 2px solid color-mix(in srgb, var(--v-border-base), transparent 9%) !important;
      border-radius: 100px;
    }
  }
}
</style>